<template>
	<section
		class="section-maker"
		v-if="
			!getStatus.home_page_products.loading &&
			getProducts.home_page_products.data.length != 0
		"
	>
		<div class="container">
			<div class="sec-maker-header text-center">
				<h3 class="sec-maker-h3">Deals</h3>
			</div>
			<div class="wrapper-content">
				<div class="outer-area-tab">
					<div class="tab-content">
						<!-- BEST SELLER PRODUCTS -->
						<div class="tab-pane active show fade" id="men-latest-products">
							<div class="row" v-if="!getStatus.home_page_products.loading">
								<div
									class="col-lg-4 col-md-4 col-sm-6 col-xs-12 mb-4"
									v-for="(products_data, index) in getProducts.home_page_products.data"
									:key="index"
								>
									<!-- <pre>{{products_data[0].category.name}}</pre> -->
									<div class="card" style="height: 100%">
										<div class="card-body">
											<h5 class="card-title font-weight-bold">
												Upto {{ Math.floor(products_data[0].percentage) }}% off on
												{{ products_data[0].category.name }}
											</h5>
											<div class="row text-center">
												<div
													@click="handleRedirect(product)"
													class="col-6 mt-2 grid_products"
													v-for="product in products_data"
													:key="product.id"
												>
													<img
														class="img-fluid"
														v-lazy="{
															src: getImage(product.lowest_price_image.path),
															loading: publicPath + 'assets/images/spinner.gif',
															error: publicPath + 'assets/images/not_found.png',
														}"
													/>
													<div style="font-size: smaller">{{ product.product_name }}</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- {{getStatus.home_page_products}} -->
		<!-- {{getProducts.home_page_products.data}} -->
	</section>
</template>

<script>
	import {mapGetters, mapActions} from "vuex";
	import {publicPath} from "../../../../vue.config";
	export default {
		data() {
			return {
				publicPath: publicPath,
			};
		},
		computed: {
			...mapGetters("products", ["getProducts", "getStatus"]),
		},
		methods: {
			...mapActions("products", ["getHomePageProducts"]),
			getImage(path) {
				return process.env.VUE_APP_API_URL + path;
			},
			handleRedirect(product) {
				this.$router.push({
					name: "ProductDetail",
					params: {id: product.id, slug: product.product_slug},
				});
			},
		},
		mounted() {
			this.getHomePageProducts();
		},
	};
</script>

<style scoped>
	.grid_products {
		cursor: pointer;
	}
</style>
